import React from 'react';
import {UserListItem} from '@/common-pages/invitation/invitation.type';
import {ReactComponent as UnreachIcon} from '@/assets/icons/invitation/unreach.svg';
import {ReactComponent as ReachedIcon} from '@/assets/icons/invitation/reached.svg';
import {ProgressBar} from 'antd-mobile';

// 单行进度条组件
interface SingleRowProgressProps {
  items: UserListItem[];
  reachedCount: number; // 已完成的项数（抵达的下标项数量）
  renderTopContent?: (item: UserListItem, index: number) => React.ReactNode;
  renderBottomContent?: (item: UserListItem, index: number) => React.ReactNode;
}

const SingleRowProgress: React.FC<SingleRowProgressProps> = ({
  items,
  reachedCount,
  renderTopContent,
  renderBottomContent,
}) => {
  // 内部进度计算
  const progress =
    items.length > 1 && reachedCount > 0
      ? ((reachedCount - 1) / (items.length - 1)) * 100
      : 0;

  return (
    <div className="px-7 flex flex-col gap-1">
      {/* 上方内容区域（金币部分） */}
      <div className="relative h-9">
        {items.map((item, i) => {
          const leftPercent = (i / (items.length - 1)) * 100;
          return (
            <div
              key={i}
              className="absolute top-1/2 -translate-y-1/2"
              style={{
                left: `calc(${leftPercent}% - 1.6875rem)`,
              }}>
              {renderTopContent && renderTopContent(item, i)}
            </div>
          );
        })}
      </div>

      {/* 进度条部分 */}
      <div className="relative">
        <ProgressBar
          percent={progress}
          rounded
          className="[--track-width:0.375rem] [--fill-color:#AC8E00] [--track-color:#CCCCCC]"
        />
        {items.map((item, i) => {
          const leftPercent = (i / (items.length - 1)) * 100;
          const isReached =
            item.invitedNumber >= item.inviteNumber && item.status === 1;

          return (
            <div
              key={i}
              className="absolute top-1/2 -translate-y-1/2"
              style={{
                left: `calc(${leftPercent}% - 0.375rem)`,
              }}>
              {isReached ? (
                <ReachedIcon className="size-3" />
              ) : (
                <UnreachIcon className="size-3" />
              )}
            </div>
          );
        })}
      </div>

      {/* 下方内容区域（用户信息部分） */}
      <div className="relative h-3">
        {items.map((item, i) => {
          const leftPercent = (i / (items.length - 1)) * 100;
          return (
            <div
              key={i}
              className="absolute top-1/2 -translate-y-1/2"
              style={{
                left: `calc(${leftPercent}% - 1.6875rem)`,
              }}>
              {renderBottomContent && renderBottomContent(item, i)}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SingleRowProgress;
